import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { useTheme } from "@/hooks/useTheme";
import { ScrollToTop } from "@/components/ScrollToTop";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import BooksPage from "@/pages/BooksPage";
import BookDetail from "@/pages/BookDetail";
import WritingsPage from "@/pages/WritingsPage";
import ArticleDetail from "@/pages/ArticleDetail";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  const { theme, toggle } = useTheme();
  useSmoothScroll();

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header theme={theme} toggle={toggle} />
        <main className="relative z-[2]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/books/:id" element={<BookDetail />} />
            <Route path="/writings" element={<WritingsPage />} />
            <Route path="/writings/:id" element={<ArticleDetail />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "var(--surface-2)",
            color: "var(--text)",
            border: "1px solid var(--border-c)",
            fontFamily: '"Plus Jakarta Sans", sans-serif',
          },
        }}
      />
    </div>
  );
}

export default App;
